import React from 'react';
import { LAYOUT, routes } from './utils/constants/routes';
import { renderRoutes } from './utils/router.utils';

const additionalProps = {};
const homePath = null;
const isRoot = true;

function App() {
  return <>{renderRoutes(Object.values(routes), LAYOUT, homePath, additionalProps, isRoot)}</>;
}

export default App;
